<template>
  <div v-if="trip" class="trip-main">

    <div class="content-block">
      <div class="trip-inputs">
        <div class="input-block status-block">
          <p>Текущий статус: </p>
          <trip-status-label class="imput-block-item status-label" :status="trip.work_status?.name || '—'"/>
        </div>

        <div class="input-block" v-if="trip.payment_terms">
          <label for="tariffType">Сроки оплаты:</label>
          <select class="imput-block-item" id="tariffType" v-model="form.payment_terms_id" >
            <option v-for="payment in options.payment_term" :key="payment.id" :value="payment.id">{{ payment.name }}</option>
          </select>
        </div>

        <div class="input-block">
          <label for="tariffType">Форма оплаты:</label>
          <select class="imput-block-item" id="payment-metods" v-model="form.payment_methods_id" >
            <option v-for="metod in options.payment_methods" :key="metod.id" :value="metod.id">{{ metod.name }}</option>
          </select>
        </div>
        <div class="input-block">
          <label for="tariffType">НДС: <span class="field-hint" title="Если меняете только НДС, ставка исполнителя подставится из ставки маршрута. Если в этом же сохранении вписали свою сумму — сохранится ваша сумма.">?</span></label>
          <select class="imput-block-item" id="payment-metods" v-model="form.nds" >
            <option :value="true">С НДС</option>
            <option :value="false">Без НДС</option>
          </select>
        </div>
        <div class="comment-input">
          <p>Итоговая сумма:</p>
          <input class="imput-block-item" type="number"  v-model="form.executor_price">
        </div>
        <div class="comment-input">
          <p>Комментарий:</p>
          <input class="imput-block-item" type="text"  v-model="form.comment_from_ati">
        </div>
        <div class="route-rate-inline">
          <div class="rate-info">
            <span class="rate-label">Ставка маршрута{{ routeName ? ' ' + routeName : '' }}:</span>
            <template v-if="loading">
              <span class="rate-loading">…</span>
            </template>
            <template v-else-if="matchedRoute">
              <strong class="rate-value">{{ formatMoney(matchedRoute.bid) }} / {{ formatMoney(matchedRoute.bid_tax) }}</strong>
              <span class="rate-hint">без НДС / с НДС</span>
            </template>
            <span v-else class="rate-missing">
              не задана — сохранение цены вернёт ошибку «нет ставок для данного маршрута»
            </span>
          </div>
          <button
            v-if="canEditRate"
            class="rate-link-btn"
            :class="{ 'rate-create': !matchedRoute && !loading }"
            :disabled="loading || !routeName"
            @click="matchedRoute ? goEdit() : goCreate()"
          >
            {{ matchedRoute ? 'Изменить' : 'Создать' }}
          </button>
        </div>
        <div class="send-save-btn">
          <button class="save-button" :disabled="saving" @click="saveChanges">{{ saving ? 'Сохраняю…' : 'Сохранить' }}</button>
        </div>
      </div>

      <div class="calculation-card">
        <div class="calculation-placeholder">
          Калькулятор временно недоступен
        </div>
      </div>
    </div>
      

  </div>
</template>

<script>
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { fetchOrders } from '@/backend/distributionApi'
import { tripFormFromTrip, tripSavePayload } from '../tripSaveLogic.mjs'


const toNumber = (value) => {
  const number = Number(String(value ?? '').replace(/\s/g, '').replace(',', '.'))
  return Number.isFinite(number) ? number : 0
}

export default {
  name: 'TripInput',
  props: ['trip'],
  setup(props, { emit }) {
    const store = useStore()
    const router = useRouter()
    const user = computed(() => store.state.user.user)
    const commentAti = ref(props.trip.comment_from_ati)
    const commentManager = ref(props.trip.comment_manager)
    const distributionCustomerPrice = ref(0)
    let distributionRequestId = 0

    // Ставка маршрута ati_route: {trip.tms_city_out}-{trip.tms_city_in}
    const routeName = computed(() => {
      const from = props.trip?.tms_city_out
      const to = props.trip?.tms_city_in
      if (!from || !to) return ''
      return `${from}-${to}`
    })
    const atiRoutes = computed(() => store.state.ati.routes)
    const atiLoading = computed(() => store.state.ati.loading)
    const matchedRoute = computed(() => {
      if (!routeName.value) return null
      const name = routeName.value.trim().toLowerCase()
      return atiRoutes.value.find((r) => r.route && r.route.trim().toLowerCase() === name) || null
    })
    // Кнопки «Изменить»/«Создать» видны ролям с правом управления ставками рейсов
    const canEditRate = computed(() => store.getters.hasPermission('ati.route.manage'))

    onMounted(() => {
      if (!atiRoutes.value.length) {
        store.dispatch('ati/getRoutes')
      }
    })

    const goEdit = () => {
      router.push({ path: '/ati-route', query: { route: routeName.value } })
    }
    const goCreate = () => {
      router.push({ path: '/ati-route', query: { route: routeName.value, new: '1' } })
    }

    onBeforeUnmount(() => {
      store.commit('cargos/clearInput')
    });
    const sendTms = () =>{
      emit('updateTrip',{id:props.trip.id,'tms_add_start':true})
    }
    
    // Форма берёт значения из рейса один раз при монтировании; после ответа
    // сервера TripDetail перемонтирует её (forceRender) уже с новыми данными.
    const form = ref(tripFormFromTrip(props.trip))
    const saving = computed(() => Boolean(store.state.cargos.tripPage.loading))

    const loadDistributionCustomerPrice = async () => {
      const tripNumber = props.trip?.trip_id
      if (!tripNumber) {
        distributionCustomerPrice.value = 0
        return
      }

      const requestId = ++distributionRequestId
      try {
        const response = await fetchOrders({ trip_id: tripNumber, limit: 1, skip: 0 })
        if (requestId !== distributionRequestId) return

        const order = Array.isArray(response?.items) ? response.items[0] : null
        distributionCustomerPrice.value = toNumber(order?.order?.cost?.start?.without_nds)
      } catch (error) {
        if (requestId === distributionRequestId) {
          distributionCustomerPrice.value = 0
        }
      }
    }

    watch(() => props.trip?.trip_id, loadDistributionCustomerPrice, { immediate: true })

    const formatMoney = (value) => `${Number(value || 0).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₽`


    // Не перерисовываем форму до ответа сервера: раньше она сразу
    // откатывалась к старым значениям, и логист сохранял по 5–7 раз.
    const saveChanges = () => {
      if (saving.value) return
      emit('updateTrip', tripSavePayload(form.value))
    }

    return {
      sendTms,
      options:computed(() => store.state.cargos.options),
      commentAti,
      commentManager,
      user,
      saveChanges,
      saving,
      form,
      formatMoney,
      routeName,
      matchedRoute,
      loading: atiLoading,
      canEditRate,
      goEdit,
      goCreate,
    }
  }
}
</script>


<style scoped>
.imput-block-item{
    width: 150px;
    margin-left: 20px;

}

.input-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.content-block{
  display: flex;
  justify-content: space-between;
  gap: 18px;
  font-size: 14px;
}

.trip-inputs {
  border: 1px solid #ccc;
  padding: 35px 20px;
  border-radius: 10px;
  margin-top: 15px;
  flex: 0 0 430px;
}

.calculation-card {
  border: 1px solid #dbe3ef;
  border-radius: 10px;
  margin-top: 15px;
  padding: 18px;
  flex: 1;
  min-width: 360px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.calculation-placeholder {
  color: #94a3b8;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  padding: 40px 16px;
}

.label {
  font-weight: bold;
}

.select {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}

.option {
  padding: 5px;
}


.save-button {
  margin-top: 2px;
  padding: 8px 12px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.field-hint {
  display: inline-block;
  width: 16px;
  height: 16px;
  line-height: 16px;
  border-radius: 50%;
  background: #e2e8f0;
  color: #475569;
  font-size: 11px;
  text-align: center;
  cursor: help;
  margin-left: 4px;
}

.save-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.comment-input{
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  align-items: center;
}

.status-block {
  margin-top: 10px;
  display: flex;
  align-items: center;
}

@media (max-width: 1100px) {
  .content-block {
    flex-direction: column;
  }

  .trip-inputs,
  .calculation-card {
    flex: auto;
    min-width: 0;
  }
}

#payment-metods{
  max-width: 150px;
}

.send-save-btn{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.route-rate-inline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
  padding: 8px 10px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  flex-wrap: wrap;
}

.rate-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  flex-wrap: wrap;
}

.rate-label {
  color: #64748b;
}

.rate-value {
  color: #111827;
  font-size: 13px;
}

.rate-hint {
  color: #94a3b8;
  font-size: 11px;
}

.rate-missing {
  color: #991b1b;
  font-size: 11px;
  line-height: 1.3;
}

.rate-loading {
  color: #6b7280;
  font-size: 12px;
}

.rate-link-btn {
  padding: 5px 12px;
  border: none;
  border-radius: 5px;
  background: #eef4ff;
  color: #1d4ed8;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.rate-link-btn:hover:not(:disabled) {
  background: #dbeafe;
}

.rate-link-btn.rate-create {
  background: #16a34a;
  color: #fff;
}

.rate-link-btn.rate-create:hover:not(:disabled) {
  background: #15803d;
}

.rate-link-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}


</style>
